var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"header"},[_c('b-container',[_c('b-row',{class:( _obj = {}, _obj[_vm.alignItems] = _vm.alignItems, _obj )},[_vm._t("left"),_vm._v(" "),_vm._t("right")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }